import React, { Fragment, useEffect, useState } from "react";
import api from "../../../../api";
import { ContainerLoader } from "../../../../components/loader";
import { IActivityListingDetails } from "../../../../core";
import { useLeadActivities } from "../../../../core/hooks/useLeadActivities";

import { ActivityItemBuilder } from "./activity-item-builder";
import UserLogs from '../../../leads/components/logs/user-logs';
import { DocumentCopyType } from '../components/List';
// import UserLogs from "../logs/user-logs";

interface IDoneActivityProps {
  activityDetails?: IActivityListingDetails;
  leadId?: string;
  allActvity?: boolean;
  customerId?: string;
  setType?: (type: string) => void;
  type?: string;
  stageCode?: string;
  genericProposalDocumentId?: string;
  documentCopyType?: DocumentCopyType;
}

export const DoneActivities: React.FunctionComponent<IDoneActivityProps> = (
  props
) => {
  const activities = props.activityDetails?.data ?? [];
  const activeFilter = props.type ?? "all";
  const isActivitiesLoading = props.activityDetails?.isLoading ?? false;
  const [isRendered, setIsRendered] = useState(false);

  const details = props.activityDetails;

  const filter: { displayText: string; key: string }[] = [
    { displayText: "All", key: "all" },
    { displayText: "Note", key: "note" },
    { displayText: "Activity", key: "activity" },
    { displayText: "Files", key: "file" },
    { displayText: "Change Log", key: "changeLog" },
  ];
  useEffect(() => {
    setIsRendered(true);
  }, []);
  // useEffect(() => {
  //   if (activeFilter !== "changeLog") {

  //   }
  // }, [activeFilter]);

  return (
    <Fragment>
      <li className="text-center mb-4 pb-2 mb-3 position-relative ">
        <span className="bg-gray-300 rounded-pill px-2 font-xxs text-uppercase">
          Done
        </span>
      </li>
      <li className="d-flex mb-4 position-relative ">
        <div className="activity-icon d-flex align-items-center justify-content-center mr-2 mt-2"></div>
        <ul
          className="nav tab-underline mb-0 border-bottom font-xs font-weight-semibold col"
          id="activity-tab"
          role="tablist"
        >
          {filter.map((p, index) => {
            return (
              <li
                onClick={() => {
                  props.setType?.(p.key === "all" ? "" : p.key);
                }}
                className="nav-item mr-4"
                role="presentation"
              >
                <a
                  className={
                    "nav-link position-relative px-0 py-2 text-gray-600 cursor-pointer " +
                    ((activeFilter || "all") === p.key ? "active" : "")
                  }
                  id={p + "-tab"}
                  data-toggle="pill"
                  // href={'#' + p}
                  role="tab"
                  aria-controls={p.key}
                  aria-selected="true"
                >
                  <span className="py-1 d-inline-flex">{p.displayText}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </li>
      {activities.length === 0 &&
        !isActivitiesLoading &&
        activeFilter !== "changeLog" && (
          <li className="text-center mb-4 pb-2 mb-3 position-relative ">
            <span className="px-2 font-sm text-uppercase">No Activities</span>
          </li>
        )}
      <Fragment>
        {activeFilter === "changeLog" ? (
          <>
          <UserLogs
            stageCode={props.stageCode}
            genericProposalDocumentId={props.genericProposalDocumentId}
            documentCopyType={props.documentCopyType}
            key={props.documentCopyType}
          ></UserLogs>
          </>
        ) : (
          // <UserLogs
          //   leadId={leadState.leadDetails?._id}
          //   customerId={props.customerId}
          // ></UserLogs>
          <div className="overflow-auto">
            {activities.map((p, index) => {
              return (
                <div key={"done-activities-" + index}>
                  {ActivityItemBuilder.builder[p.type] != null &&
                    ActivityItemBuilder.builder[p.type](p, props.leadId)}
                </div>
              );
            })}
            {/* {!isActivitiesLoading &&
              (details?.data?.length ?? 0) < (details?.totalCount ?? 0) &&
              (details?.data?.length ?? 0) !== 0 && (
                <div className="text-center">
                  <span
                    onClick={() => {
                      // loadActivities((details?.page ?? 0) + 1);
                    }}
                    className="rounded-pill px-2 font-xxs text-uppercase cursor-pointer"
                  >
                    Load more
                  </span>
                </div>
              )}
            {isActivitiesLoading && <ContainerLoader></ContainerLoader>} */}
          </div>
        )}
      </Fragment>
    </Fragment>
  );
};
